import "./Loading.css";
import { useTranslation } from "react-i18next";

const Loading = () => {
  const { t } = useTranslation();

  return (
    <div className="loading-container" data-testid="loading">
      <div className="loading-spinner" role="status"></div>
      <p className="loading-text">{t('common.loading')}</p>
    </div>
  );

}

export default Loading;
